module.exports = __webpack_public_path__ + "img/open.cfc73ddf.svg";